import { create } from 'zustand';

/** What the server said about the desk in front of the player (ADR-0042). */
export interface DeskPrompt {
  readonly objectId: number;
  readonly name: string;
  readonly state: 'free' | 'mine' | 'taken';
  /** Display name of whoever holds a `taken` desk. */
  readonly holder?: string;
  /** Set when the last assign or release did not go through. */
  readonly problem?: 'taken' | 'failed';
}

interface DeskState {
  /** The desk question on screen, or `undefined` when it is closed. */
  prompt: DeskPrompt | undefined;
  show(prompt: DeskPrompt): void;
  setProblem(problem: 'taken' | 'failed'): void;
  close(): void;
}

export const useDeskStore = create<DeskState>((set) => ({
  prompt: undefined,
  show: (prompt) => set({ prompt }),
  setProblem: (problem) =>
    set((state) => (state.prompt ? { prompt: { ...state.prompt, problem } } : state)),
  close: () => set({ prompt: undefined }),
}));
